module.exports = __webpack_public_path__ + "static/img/logo-max.af6a464e.png";